import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import SpeakerListing from 'views/admin/speakers/SpeakerListing'
import SpeakerForm from 'views/admin/speakers/SpeakerForm'

const Speakers = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <SpeakerListing />
      </Route>
      <Route path={`${path}/new`}>
        <SpeakerForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:speakerId`}>
        <SpeakerForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default Speakers
